import { gql } from '@apollo/client'
import { Price } from '@jusbrasil-web/shared-price'

import { PlanFrequency } from '../../../../constants'
import { OfferCardPrice_OfferLockOfferFragment } from './__generated__/offer-card-price.graphql'

interface OfferCardPriceProps {
  offerLockOffer: OfferCardPrice_OfferLockOfferFragment
  className?: string
}

export const OfferCardPrice = ({ className, offerLockOffer }: OfferCardPriceProps) => {
  const {
    priceTitle,
    priceTitlePlansSection,
    frequency,
    priceText,
    frequencyPeriodText,
    priceAfterPromotionalPeriodText,
  } = offerLockOffer

  const isPromotional = !!priceAfterPromotionalPeriodText
  const isYearlyPlan = frequency === PlanFrequency.YEARLY

  const getPriceText = () => {
    if (isPromotional) {
      return (
        <>
          <Price.Value>{priceText}</Price.Value>
          <Price.Helptext> no {frequencyPeriodText}</Price.Helptext>
        </>
      )
    }

    return (
      <span>
        <Price.Value>{priceText}</Price.Value>
        {!isYearlyPlan && frequency && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}
      </span>
    )
  }

  return (
    <Price className={className}>
      {priceTitlePlansSection && (
        <Price.Title>
          <span dangerouslySetInnerHTML={{ __html: priceTitlePlansSection }} />
        </Price.Title>
      )}

      {getPriceText()}
      <Price.Helptext>
        <span dangerouslySetInnerHTML={{ __html: priceTitle }} />
      </Price.Helptext>
    </Price>
  )
}

OfferCardPrice.fragments = {
  offerLockOffer: gql`
    fragment OfferCardPrice_offerLockOffer on OfferLockOffer {
      priceTitle
      priceTitlePlansSection
      priceText
      frequency
      frequencyPeriodText
      priceAfterPromotionalPeriodText
    }
  `,
}
